// extracted by mini-css-extract-plugin
export default {"cls1":"UserForm-ToggleGridRow_cls1__T+7Qf","cls2":"UserForm-ToggleGridRow_cls2__ZnRFu UserForm-ToggleGridRow_cls1__T+7Qf"};